import React, { useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { Ripple } from "primereact/ripple";
import './AppMenu.css';
import { SystemConfig } from './config/SystemConfig';

const AppSubmenuItem = ({ item, index, root, activeIndex, setActiveIndex, onMenuItemClick }) => {
    const active = activeIndex === index;
    const nodeRef = useRef(null);

    const itemClick = (event) => {
        //avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        //execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }

        if (index === activeIndex)
            setActiveIndex(null);
        else
            setActiveIndex(index);

        if (onMenuItemClick) {
            onMenuItemClick({
                originalEvent: event,
                item: item
            });
        }
    };

    const renderLinkContent = () => {
        let submenuIcon = item.items && <i className="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>;
        let badge = item.badge && <span className="menuitem-badge">{item.badge}</span>;

        return (
            <React.Fragment>
                <i className={item.icon}></i>
                <span>{item.label}</span>
                {submenuIcon}
                {badge}
                <Ripple />
            </React.Fragment>
        );
    };

    const renderLink = () => {
        let content = renderLinkContent();

        if (item.to) {
            return (
                <NavLink className={({ isActive }) => "p-ripple" + (isActive ? " router-link-active router-link-exact-active" : "")} to={item.to} onClick={itemClick} target={item.target} end="true">
                    {content}
                </NavLink>
            )
        }
        else {
            return (
                <a href={item.url} className="p-ripple" onClick={itemClick} target={item.target}>
                    {content}
                </a>
            );
        }
    };

    let styleClass = classNames(item.badgeStyleClass, { 'layout-menuitem-category': root, 'active-menuitem': active && !item.to });

    if (root) {
        return (
            <li className={styleClass} key={index}>
                <div className="layout-menuitem-root-text">{item.label}</div>
                <AppSubmenu items={item.items} onMenuItemClick={onMenuItemClick} />
            </li>
        );
    }
    else {
        return (
            <li className={styleClass} key={index}>
                {renderLink()}
                <CSSTransition nodeRef={nodeRef} classNames="layout-submenu-wrapper" timeout={{ enter: 1000, exit: 450 }} in={active} unmountOnExit>
                    <AppSubmenu ref={nodeRef} items={item.items} onMenuItemClick={onMenuItemClick} />
                </CSSTransition>
            </li>
        );
    }
};

const AppSubmenu = React.forwardRef((props, ref) => {
    const [activeIndex, setActiveIndex] = useState(null)

    let items = props.items && props.items.map((item, i) => {
        return <AppSubmenuItem key={i} item={item} index={i} root={props.root} activeIndex={activeIndex} setActiveIndex={setActiveIndex} onMenuItemClick={props.onMenuItemClick} />;
    });

    return items ? <ul ref={ref} className={props.className}>{items}</ul> : null;
});

export const AppMenu = (props) => {
    return (
        <div className="layout-sidebar">
            <div className="layout-menu-container">
                {/* Contenido del menú */}
                <AppSubmenu items={props.model} className="layout-menu" onMenuItemClick={props.onMenuItemClick} root={true} />

                {/* Footer pegado al final */}
                <div className="layout-menu-footer flex align-items-center justify-content-center mt-3">
                    <img src={SystemConfig.logoPath} alt="Logo" height="20" className="mr-2" />
                    <span className="text-sm font-medium" style={{ color: 'var(--text-secondary)' }}>{SystemConfig.footerText.replace('{year}', new Date().getFullYear())}</span>
                </div>
            </div>
        </div>
    );
}
